import browser from './browser';
import handlers from './handlers';

const mocks = {
  browser,
  handlers,
};

export default mocks;
